import { SvgIcon } from "@mui/material";

export default function EditWhite(props) {
  return (
    <SvgIcon
      fontSize="small"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.6562 1.53125C13.3438 0.875 14.4375 0.875 15.125 1.53125L16.4688 2.875C17.125 3.5625 17.125 4.65625 16.4688 5.34375L6.6875 15.125C6.3125 15.4688 5.875 15.75 5.40625 15.875L1.625 17C1.4375 17.0312 1.25 17 1.125 16.875C1 16.75 0.9375 16.5625 1 16.375L2.125 12.5938C2.25 12.125 2.53125 11.6875 2.875 11.3125L12.6562 1.53125ZM14.4062 2.25C14.125 1.96875 13.6562 1.96875 13.3438 2.25L11.6562 3.96875L14.0312 6.34375L15.75 4.65625C16.0312 4.34375 16.0312 3.875 15.75 3.59375L14.4062 2.25ZM4.40625 13.5938L6.40625 14L13.3125 7.0625L10.9375 4.65625L4 11.5938L4.40625 13.5938ZM3.1875 12.5938C3.15625 12.6875 3.09375 12.7812 3.0625 12.875L2.21875 15.7812L5.125 14.9375C5.21875 14.9062 5.3125 14.8438 5.40625 14.8125L3.875 14.5C3.6875 14.4688 3.53125 14.3125 3.5 14.125L3.1875 12.5938Z" />
    </SvgIcon>
  );
}
